import { SessionStorageKey } from "@components/refactored-survey/question-sets/insurance-survey-questions/utils/SessionStorageKey";

// This is `true` for users that are new to Noom and do not have existing accounts.
// This is `false` or undefined for users that have been sent an email to sign up for telehealth.
export const getIsTelehealthBuyflow = (): boolean =>
  sessionStorage.getItem(SessionStorageKey.isTelehealthBuyflow) ===
  true.toString();

export const setIsTelehealthBuyflow = (value: boolean): void => {
  sessionStorage.setItem(
    SessionStorageKey.isTelehealthBuyflow,
    value.toString()
  );
};
